<template>
  <!-- 订舱 -->
  <div class="Booking">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div class="typeArea">
      <div class="img">
        <div class="img-title">全程贴心服务与您同在</div>
        <div class="img-word">集成主流船东电商和一手庄家舱位的在线服务平台</div>
        <!-- <img src="../../assets/images/toolsBgImg.png" alt="" /> -->
      </div>
      <div class="con">
        <!-- 菜单 -->
        <el-menu
          :default-active="menuInx"
          class="el-menu-vertical-demo"
          @select="handleSelect"
        >
          <el-menu-item index="1">
            <span slot="title">码头箱动态</span>
          </el-menu-item>
          <el-menu-item index="2">
            <span slot="title">船公司</span>
          </el-menu-item>
          <el-menu-item index="3">
            <span slot="title">港口百科</span>
          </el-menu-item>
        </el-menu>

        <!-- 内容 -->
        <div class="menu-con">
          <div class="yi" v-if="menuInx == 1">
            <div class="titl">
              码头箱动态<span> - 全国主要口岸码头箱动态查询</span>
            </div>
            <div class="mtx">
              <div class="dynamics-con">
                <!-- 循环 -->
                <div class="dynamics-son" v-for="(item,index) in dockContainerList" :key="index">
                  <div class="leftimg">
                    <img :src="item.logo" alt="">
                    <span>{{item.name_cn+' '+item.name_en}}</span>
                  </div>
                  <div class="centerNr">
                    <a class="haizi" v-for="(it,idx) in item.showchild" :key="idx" :href="it.url" target="_blank">
                      <div class="xian"></div>
                      <div class="neir">
                        <div class="nr-logo">
                          <img :src="it.logo" alt="">
                        </div>
                        <div class="nr-name">
                          {{it.title}}
                        </div>
                        <div class="nr-con">{{it.content}}</div>
                      </div>
                    </a>
                  </div>
                  <div v-show="item.showchild.length>0" class="rightimg">
                    <!-- <div @click="backData(item)" class="icom" :class="{'icomer' : item.left}">
                      <i class="el-icon-arrow-left iconn"></i>
                    </div>
                    <div @click="nextData(item)" class="icom" :class="{'icomer' : item.right}">
                      <i class="el-icon-arrow-right iconn"></i>
                    </div> -->
                    <el-button @click="backData(item)" :disabled="!item.left" class="icom" :class="{'icomer' : item.left}" icon="el-icon-arrow-left" circle></el-button>
                    <el-button @click="nextData(item)" :disabled="!item.right" class="icom" :class="{'icomer' : item.right}" icon="el-icon-arrow-right" circle></el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="menuInx == 2">
            <div class="titl">船公司<span> - 订舱官网</span></div>
            <div class="company">
              <div
                v-for="(item, index) in shippingList"
                :key="index"
                class="gsyi"
                :class="(index + 1) % 4 == 0 ? 'gser' : ''"
              >
                <a :href="item.url" target="_blank" v-if="item.url!=''">
                  <img :src="item.cover" alt="" />
                </a>
                <div :href="item.url" target="_blank"  v-else>
                  <img :src="item.cover" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="menuInx == 3">
            <div class="search">
              <div class="titl">港口百科<span> - 港口大全</span></div>
              <el-input
                placeholder="请输入港口名称"
                v-model="portValue"
                class="input-with-select"
              >
                <el-button @click="searchPort" slot="append">查询</el-button>
              </el-input>
            </div>
            <el-empty v-if="muDgList.length==0" description="暂无数据"></el-empty>
            <el-tabs v-if="muDgList.length>0" class="mudig" v-model="activeName">
              <el-tab-pane
                :key="index"
                v-for="(item,index) in muDgList"
                :label="item.route_name"
                :name="item.route_name"
              >
              <div v-if="item.tag_arr.length==0" class="zanwu">
                暂无数据
              </div>
              <div v-else>
                <div
                  v-for="(it,idx) in item.tag_arr"
                  :key="idx"
                  class="mdglist"
                >
                  
                  <div class="tagtitle">
                    {{ it.tag_name }}
                  </div>
                  <div class="porttitle">
                    <div v-for="(at,adx) in it.port_arr" :key="adx">
                      {{ at.port_name + "-" + at.name_en }}
                    </div>
                  </div>
                </div>
              </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <Bottom />
  </div>
</template>
    
<script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import { destinationPortRouteTypeValidList,baseShippingCompanyValidList,validList } from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      // 展示菜单内容
      menuInx: "1",
      MaTouXiangList: [],
      dockContainerList:[],
      // 默认显示第一个港口数据
      activeName: "",
      // 港口列表
      muDgList: [],
      //查询港口内容
      portValue: "",
      shippingList:[],
      canshu:{},
    };
  },
  methods: {
    handleSelect(key) {
      this.menuInx = key;
    },
    // 目的港
    async getMdgList() {
      // 目的港列表
      const res = await destinationPortRouteTypeValidList();
      if (res.code == 1) {
        this.muDgList = res.data;
        this.activeName = res.data[0].route_name;
      }
    },
    // 船公司
    async getShippingList() {
      const res = await baseShippingCompanyValidList();
      if (res.code == 1) {
        this.shippingList = res.data;
      }
    },
    // 码头箱动态
    async getValidList() {
      const res = await validList();
      if (res.code == 1) {
        this.MaTouXiangList = res.data;
        this.dockContainerList = res.data;

        for (let i = 0; i < this.dockContainerList.length; i++) {
          this.dockContainerList[i].dc_id = i //id
          let haizi = this.dockContainerList[i].dynamics
          this.dockContainerList[i].page_no=1 //页码
          this.dockContainerList[i].total=haizi.length //总长度
          this.dockContainerList[i].left=false //左侧按钮是否可以点击
          this.dockContainerList[i].right=false //右侧按钮是否可以点击
          this.dockContainerList[i].showchild=[] // 展示的数据

          if(haizi.length>2){
            this.dockContainerList[i].showchild = [haizi[0],haizi[1]]
            this.dockContainerList[i].right=true
          }else if(haizi.length==2){
            this.dockContainerList[i].showchild = [haizi[0],haizi[1]]
          }else if(haizi.length==1){
            this.dockContainerList[i].showchild = [haizi[0]]
          }else{
            this.dockContainerList[i].showchild = []
          }
        }
      }
    },
    // 切换数据
    // 下一页
    nextData(e){
      let index = e.dc_id
      let haizi = this.dockContainerList[index]
      haizi.page_no += 1
      haizi.left = true
      if(haizi.total <= Number(haizi.page_no)*2){
        haizi.right = false
        if(haizi.total == Number(haizi.page_no)*2){
          haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2],haizi.dynamics[Number(haizi.page_no)*2-1]]
        }else{
          haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2]]
        }
      }else{
        haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2],haizi.dynamics[Number(haizi.page_no)*2-1]]
      }
      this.dockContainerList[index] = haizi
      this.dockContainerList=[...this.dockContainerList]
    },
    // // 上一页
    backData(e){
      let index = e.dc_id
      let haizi = this.dockContainerList[index]

      haizi.page_no -= 1
      haizi.left = true
      haizi.showchild=[haizi.dynamics[Number(haizi.page_no)*2-2],haizi.dynamics[Number(haizi.page_no)*2-1]]
      haizi.right = true
      if(haizi.page_no==1){
        haizi.left = false
      }else{
        haizi.left = true
      }
      this.dockContainerList[index] = haizi
      this.dockContainerList=[...this.dockContainerList]
    },
    async searchPort(){
      try {
        const res = await destinationPortRouteTypeValidList({
          keyword:this.portValue
        })
        this.muDgList = res.data;
        this.activeName = res.data[0].route_name;
      } catch (error) {
        console.log(error,'失败');
      }
    }
  },
  
  mounted() {
    this.getValidList()
    this.getMdgList();
    this.getShippingList()

    this.canshu = this.$route.params
    if(this.canshu.menuInx){
      this.menuInx = this.canshu.menuInx
    }
  },
};
</script>
    
<style style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.Booking {
  background: #f9f9f9;
}
.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}

.img {
  height: 200px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
  // opacity: 0.15;
  margin-bottom: 20px;

  background-image:url('../../assets/images/toolsBgImg.png');	
  background-repeat: no-repeat;
  background-size:100% 100%;

  .img-title{
    margin-top: 58px;
    margin-left: 58px;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 36px;
    color: #FFFFFF;
    line-height: 42px;
    text-align: left;
  }

  .img-word{
    font-weight: 500;
    font-size: 20px;
    color: #FFFFFF;
    line-height: 23px;
    margin-top: 6px;
    margin-left: 58px;
  }
}

.con {
  margin-bottom: 20px;

  display: flex;
  justify-content: space-between;

  .el-menu {
    width: 200px;
    height: 166px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;

    border: 0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #999999;
    font-style: normal;
    text-transform: none;

    overflow: hidden;
    li {
      // height: 32px;
      display: flex;
      align-items: center;
    }
  }

  .is-active {
    border-left: solid 2px #0073f5;
    color: #0073f5;
  }

  .menu-con {
    width: 976px;
    background: #fff;
    padding: 32px;
    border-radius: 12px 12px 12px 12px;
    box-sizing: border-box;
  }

  .titl {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 24px;

    span {
      color: #999;
      font-size: 14px;
    }
  }

  .yi {
    .mtx {
      .dynamics-con{
        .dynamics-son{
          width: 912px;
          height: 82px;
          background: #FFFFFF;
          box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.06);
          border-radius: 6px 6px 6px 6px;
          margin: 0 auto 28px;

          display: flex;
          align-items: center;
          .leftimg{
            width: 240px;
            position: relative;
            img{
              width: 170px;
              height: 68px;
              margin-top: 14px;
            }
            span{
              font-weight: 600;
              font-size: 16px;
              color: #2E3655;
              position: absolute;
              top: 30px;
              left: 74px;
            }
          }

          .centerNr{
            display: flex;
            align-items: center;
            width: 570px;
            .xian{
              width: 0px;
              height: 27px;
              border-radius: 0px 0px 0px 0px;
              border: 1px solid #EDEBEB;
              margin-right: 38px;
            }
            .haizi{
              width: 284px;
              display: flex;
              align-items: center;
              text-decoration: none;
              .nr-logo{
                img{
                  height: 21px;
                }
              }

              .nr-name{
                font-weight: 500;
                font-size: 14px;
                color: #2E3655;
                width: 208px;
                line-height: 20px;
                overflow: hidden; /* 隐藏超出部分 */
                white-space: nowrap; /* 不换行 */
                text-overflow: ellipsis; /* 超出部分显示为省略号 */
              }

              .nr-con{
                font-weight: 400;
                font-size: 12px;
                color: #787E93;
                width: 208px;
                line-height: 18px;
                overflow: hidden; /* 隐藏超出部分 */
                white-space: nowrap; /* 不换行 */
                text-overflow: ellipsis; /* 超出部分显示为省略号 */
              }
            }
          }

          .rightimg{
            width: 114px;
            // height: 100%;
            display: flex;
            .icom{
              width: 28px;
              height: 28px;
              margin-right: 20px;
              // cursor: pointer;
              border: #D3D3D3 1px solid;
              color: #D3D3D3;
              border-radius: 2px  2px  2px  2px;
              background: #fff;
              display: flex;
              align-items: center; 
              justify-content: center;       
            }

            .icomer:hover{
              border: #064FAF 1px solid;
              color: #064FAF;
            }

            .icomer{
              border: #D3D3D3 1px solid;
              color: #4E4949;
            }
          }
        }
      }
    }
  }

  .company {
    display: flex;
    flex-wrap: wrap;
    .gsyi {
      width: 210px;
      height: 110px;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #eeeeee;

      margin-right: 20px;
      margin-bottom: 20px;
      img {
        width: 210px;
        height: 110px;
      }
    }
    .gser {
      margin-right: 0px;
    }
  }

  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .titl {
      margin-bottom: 0;
    }
    :deep(.el-input) {
      width: 320px;
      height: 48px;
      border-radius: 8px 8px 8px 8px;
      overflow: hidden;
      input {
        height: 48px;
        background: #f9f9f9;
        border: 0;
      }

      input::placeholder {
        color: #999;
      }
    }

    .el-button {
      width: 80px;
      height: 48px;
      background: #0073f5;
      border-radius: 0px 8px 8px 0px;
      color: #fff;
    }
  }

  .guo {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    border-left: 3px #0073f5 solid;

    padding-left: 8px;
  }

  .el-tabs {
    .el-button {
      width: 168px;
      height: 36px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      font-style: normal;
      text-transform: none;
      margin: 0;
      padding: 0;
      text-align: center;

      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: 16px;
    }

    .el-button:hover {
      color: #0073f5;
      border: 1px solid #0073f5;
      background: #edf6ff;
    }
  }

  ::v-deep .el-tabs__item.is-active {
    color: #0073f5; //选中
  }

  ::v-deep .el-tabs__item:hover {
    color: #0073f5; //hover
    // cursor: pointer;
  }
  // 普通字体颜色
  ::v-deep .el-tabs__item {
    color: #606260; //悬浮
    // cursor: pointer;
    font-size: 16px;
  }

  // 下划线颜色
  ::v-deep .el-tabs__active-bar {
    background-color: #0073f5;
  }
}

.mudig {
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  //   width: 500px;
  .tagtitle {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding-left: 8px;
    border-left: 5px solid #0073f5;
    margin-bottom: 24px;
  }

  .porttitle {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 32px;
    div {
      width: 166px;
      height: 20px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      white-space: nowrap; /* 文本不换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 显示省略号 */
      margin-bottom: 8px;
      margin-right: 8px;
    }
  }
}

.zanwu{
  text-align: center;
  color: #999;
}
</style>